/* Mega menu + mobile drawer.

   A direct port of components/MegaMenu.tsx and components/Drawer.tsx. Nothing
   here is delegated on `document` the way Horizon does it, so `currentTarget`
   behaves normally — but listeners are still attached per element rather than
   globally, which is what makes that true.

   No custom elements, so no `-component` naming rule and no upgrade race. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- mega */
  var nav = document.querySelector('[data-aw-nav]');
  if (nav) {
    var closeTimer = null;
    var openItem = null;

    function cancelClose() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function setOpen(item) {
      if (openItem && openItem !== item) close(openItem);
      openItem = item;
      if (!item) return;
      var panel = item.querySelector('[data-aw-panel]');
      var trigger = item.querySelector('[data-aw-trigger]');
      if (!panel) return;
      panel.hidden = false;
      panel.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function close(item) {
      var target = item || openItem;
      if (!target) return;
      var panel = target.querySelector('[data-aw-panel]');
      var trigger = target.querySelector('[data-aw-trigger]');
      if (panel) {
        panel.hidden = true;
        panel.classList.remove('is-open');
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (target === openItem) openItem = null;
    }

    /* Closing is delayed ~120ms so a diagonal mouse path into the panel does
       not snap it shut — the classic hover trap. */
    function scheduleClose() {
      cancelClose();
      closeTimer = window.setTimeout(function () { close(); }, 120);
    }

    Array.prototype.forEach.call(nav.querySelectorAll('[data-aw-nav-item]'), function (item) {
      var trigger = item.querySelector('[data-aw-trigger]');

      item.addEventListener('mouseenter', function () { cancelClose(); setOpen(item); });
      item.addEventListener('mouseleave', scheduleClose);

      /* Opens on hover AND on click/Enter/Space, so pointer and keyboard users
         get the same affordance. */
      item.addEventListener('focusin', function () { cancelClose(); setOpen(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });

      if (trigger) {
        trigger.addEventListener('click', function () {
          if (openItem === item) close(item); else { cancelClose(); setOpen(item); }
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var trigger = openItem.querySelector('[data-aw-trigger]');
      close();
      if (trigger) trigger.focus();
    });

    document.addEventListener('pointerdown', function (e) {
      if (openItem && !nav.contains(e.target)) close();
    });
  }

  /* -------------------------------------------------------------- drawer */
  var drawer = document.querySelector('[data-aw-drawer]');
  var burger = document.querySelector('[data-aw-burger]');
  var scrim = document.querySelector('[data-aw-scrim]');

  if (drawer && burger) {
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    var isOpen = false;
    var prevOverflow = '';
    var prevPad = '';

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;

      /* Scroll lock without the page jumping: the scrollbar width is given
         back as padding. */
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      prevOverflow = document.body.style.overflow;
      prevPad = document.body.style.paddingRight;
      document.body.style.overflow = 'hidden';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';

      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      burger.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-open');

      /* Land on the close button rather than the logo — it is the action a
         returning user most often wants, and it announces the way out. */
      var first = drawer.querySelector('.drawer__close') || drawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPad;
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      burger.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.classList.remove('is-open');
      burger.focus();
    }

    burger.addEventListener('click', openDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-aw-drawer-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });
    /* A link inside the drawer navigates; close so the state is not restored
       open by the back/forward cache. */
    Array.prototype.forEach.call(drawer.querySelectorAll('a[href]'), function (a) {
      a.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        drawer.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var firstEl = items[0];
      var lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) {
        e.preventDefault(); lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault(); firstEl.focus();
      }
    });

    /* Disclosures inside the drawer. `hidden` is used for the collapsed state
       so the panel leaves the tab order; aw.css carries the
       `.aw [hidden] { display: none !important }` that makes the attribute
       actually win against our own display rules. */
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-aw-disclosure]'), function (btn, i) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (i === 0) {
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.classList.add('is-open');
      }
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
        panel.classList.toggle('is-open', !expanded);
      });
    });
  }
})();
